import React from 'react';
import clsx from 'clsx';
import SearchBar from '../SearchBar/SearchBar';

export default class ConsolidatedNavigation extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div
				className={
					'consolidated-navigation consolidated-navigation-' +
					(typeof this.props.viewport != 'undefined'
						? this.props.viewport
						: 'desktop')
				}
			>
				<div className="panel">
					<div className="panel-body">
						{this.renderButtons()}

						<SearchBar {...this.props} />
					</div>
				</div>
			</div>
		);
	}

	renderButtons() {
		var displayMyCourses = this.props.user_id ? true : false;
		var displayAllCalculators = this.props.all_calculators_path ? true : false;

		var btnGroupClasses = clsx({
			'btn-group': true,
			'single-item':
				displayMyCourses == false && displayAllCalculators == false,
			'three-items': displayMyCourses == true && displayAllCalculators == true
		});

		var viewport = this.props.viewport || 'desktop';

		return (
			<div
				className={btnGroupClasses}
				role="tablist"
				id={'consolidated-navigation' + viewport}
			>
				<a
					href={this.props.all_courses_path}
					className={
						'btn btn-default ' +
						(this.props.page_context == 'all_courses' ? 'active' : '')
					}
					role="tab"
					aria-selected={this.props.page_context == 'all_courses'}
					aria-controls={'consolidated-navigation' + viewport}
					tabIndex={this.props.page_context == 'all_courses' ? -1 : 0}
				>
					{I18n.t('all_courses')}
				</a>
				{displayMyCourses && (
					<a
						href={this.props.my_courses_path}
						className={
							'btn btn-default ' +
							(this.props.page_context == 'my_courses' ? 'active' : '')
						}
						role="tab"
						aria-selected={this.props.page_context == 'my_courses'}
						aria-controls={'consolidated-navigation' + viewport}
						tabIndex={this.props.page_context == 'my_courses' ? -1 : 0}
					>
						{I18n.t('my_courses')}
					</a>
				)}
				{displayAllCalculators && (
					<a
						href={this.props.all_calculators_path}
						className={
							'btn btn-default ' +
							(this.props.page_context == 'all_calculators' ? 'active' : '')
						}
						role="tab"
						aria-selected={this.props.page_context == 'all_calculators'}
						aria-controls={'consolidated-navigation' + viewport}
						tabIndex={this.props.page_context == 'all_calculators' ? -1 : 0}
					>
						{I18n.t('all_calculators')}
					</a>
				)}
			</div>
		);
	}
}
